// Module
var code = `<div class="js-instrument-lookup {{.elementStyle}} {{#.haveError}}js-input-container-error{{/}}" on-mousedown="@this.onMouseDown(event)" style="{{>visibility}}" {{>visualparameters}}>

    {{# showInsTypeImg}}
        <InstrumentTypeLogoRactive 
            instrument="{{currentInstrument}}"
            tooltip="{{insTypeImgTT}}"
            on-logoClick="@this.onInsTypeImgMouseDown(event)"
            isNeedHoverEffect="true"
            disabled="{{!enabled}}" />
    {{/}}

    <form autocomplete="off" on-submit="@this.onSubmitEvent(event)">
        <input type="text"
        maxlength="{{.maxLength}}"
        placeholder="{{.placeholder}}"
        spellcheck="false"
        value="{{.text}}"
        as-tooltip="tooltip"
        on-focus="focus"
        on-blur="blur"
        on-keydown="keyDown"
        on-keyup="keyUp"
        on-wheel="mouseWheel"
        on-mousewheel="mouseWheel"
        {{#.autofocus}} autofocus {{/}}
        {{#.isReadOnly}} readonly {{/}}
        autocomplete="off" />
    </form>

    {{# hasDelay}}
    <div class="class-delayed-ico" as-tooltip="delayedTooltip">
        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#delayedData"></use>
        </svg>
    </div>
    {{/}}

</div>`;
// Exports
export default code;